import * as React from "react";

function SvgAuryc(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 213.48 163.22"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <linearGradient
          id="Auryc_svg__New_Gradient_Swatch_2"
          x1={107.57}
          y1={122.77}
          x2={107.63}
          y2={122.77}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fee71a" />
          <stop offset={1} stopColor="#f8c454" />
        </linearGradient>
        <linearGradient
          id="Auryc_svg__New_Gradient_Swatch_2-2"
          x1={107.58}
          y1={96.03}
          x2={107.63}
          y2={96.03}
          xlinkHref="#Auryc_svg__New_Gradient_Swatch_2"
        />
        <linearGradient
          id="Auryc_svg__New_Gradient_Swatch_2-3"
          x1={107.61}
          y1={68.52}
          x2={107.63}
          y2={68.52}
          xlinkHref="#Auryc_svg__New_Gradient_Swatch_2"
        />
        <linearGradient
          id="Auryc_svg__New_Gradient_Swatch_2-4"
          x1={20}
          y1={81.08}
          x2={195.27}
          y2={81.08}
          xlinkHref="#Auryc_svg__New_Gradient_Swatch_2"
        />
        <linearGradient
          id="Auryc_svg__New_Gradient_Swatch_2-5"
          x1={107.58}
          y1={122.77}
          x2={107.63}
          y2={122.77}
          xlinkHref="#Auryc_svg__New_Gradient_Swatch_2"
        />
        <linearGradient
          id="Auryc_svg__New_Gradient_Swatch_2-6"
          x1={107.58}
          y1={96.03}
          x2={107.63}
          y2={96.03}
          xlinkHref="#Auryc_svg__New_Gradient_Swatch_2"
        />
        <linearGradient
          id="Auryc_svg__New_Gradient_Swatch_2-7"
          x1={107.61}
          y1={68.52}
          x2={107.63}
          y2={68.52}
          xlinkHref="#Auryc_svg__New_Gradient_Swatch_2"
        />
        <style />
      </defs>
      <g id="Auryc_svg__Layer_4" data-name="Layer 4">
        <path
          d="M158.26 91.64l-37.12 22.86-5.14 3.15-1.87 1.14-2.41 1.48-1 .6a6 6 0 01-3.12.88v-10.7L153 83.12a5 5 0 015.24 8.52z"
          fill="#89acf1"
        />
        <path
          d="M129.86 82.37l-8.73 5.38-7 4.3-2.41 1.48-1 .6a6 6 0 01-3.12.88V84.32l17-10.46a5 5 0 115.24 8.51z"
          fill="#ff7575"
        />
        <path
          d="M125.51 57.57l-4.39 2.7-9.39 5.78-1 .6a6 6 0 01-3.12.88V56.82l12.64-7.77a5 5 0 015.24 8.52z"
          fill="#74cdb0"
        />
        <path
          d="M107.63 122.75v.05h-.06z"
          fill="url(#Auryc_svg__New_Gradient_Swatch_2)"
        />
        <path
          d="M107.63 96h-.05z"
          fill="url(#Auryc_svg__New_Gradient_Swatch_2-2)"
        />
        <path
          d="M107.63 68.51z"
          fill="url(#Auryc_svg__New_Gradient_Swatch_2-3)"
        />
        <path
          d="M192.83 89.38l-79.64-77.12a8 8 0 00-11.13 0L22.43 89.39a8 8 0 001.38 12.55l79.63 49a7.92 7.92 0 008.38 0l79.64-49a8 8 0 001.37-12.56zm-85.2 52.42l-76.39-47 12-11.62 50.9 31.33 10.59 6.49.12.07a5.89 5.89 0 002.72.65v-10.7L50.65 76l9.47-9.18 34 21 10.69 6.58a5.89 5.89 0 002.72.65V84.3L67.54 59.62l9.72-9.42L94 60.28l1.28.78 9.63 5.81a5.89 5.89 0 002.72.65v-10.7L84.69 43l22.94-22.2 76.4 74z"
          fill="url(#Auryc_svg__New_Gradient_Swatch_2-4)"
        />
        <path
          d="M107.63 122.75v.05z"
          fill="url(#Auryc_svg__New_Gradient_Swatch_2-5)"
        />
        <path d="M107.63 96z" fill="url(#Auryc_svg__New_Gradient_Swatch_2-6)" />
        <path
          d="M107.63 68.51z"
          fill="url(#Auryc_svg__New_Gradient_Swatch_2-7)"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAuryc);
